module.exports = __webpack_public_path__ + "bin/3d2fb10920c573caaa547b347582f1de.svg";